'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _DayPickerInput = require('react-day-picker/DayPickerInput');var _DayPickerInput2 = _interopRequireDefault(_DayPickerInput);
require('react-day-picker/lib/style.css');
var _moment = require('react-day-picker/moment');



var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _OMDatePicker = require('./OMDatePicker.scss');var styles = _interopRequireWildcard(_OMDatePicker);
require('./DatePickerOverrides.css');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var DATE_FORMAT = 'DD/MM/YYYY';
var MODIFIERS = {
  disabled: { before: new Date() } };var


OMDatePicker = function (_Component) {_inherits(OMDatePicker, _Component);function OMDatePicker() {var _temp, _this, _ret;_classCallCheck(this, OMDatePicker);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      date: _this.props.value ? new Date(_this.props.value) : '' }, _this.


    componentWillReceiveProps = function (_ref) {var value = _ref.value;
      if (value !== _this.props.value) {
        _this.setState({ date: value ? new Date(value) : '' });
      }
    }, _this.

    clearDate = function () {
      _this.setState({ date: '' });
      _this.props.onSelect('');
    }, _this.

    handleIconClick = function () {
      _this.datepickerRef && _this.datepickerRef.showDayPicker();
    }, _this.

    handleChange = function (date, _ref2) {var disabled = _ref2.disabled;
      if (disabled) {return null;}

      if (!date) {
        return _this.props.onSelect('');
      }

      var today = new Date();
      var isoDate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0));

      var setDate = new Date(date).setHours(0, 0, 0, 0) < isoDate.valueOf() ?
      isoDate :
      date;

      _this.setState({
        date: setDate });


      return _this.props.onSelect(setDate.toISOString());
    }, _temp), _possibleConstructorReturn(_this, _ret);}OMDatePicker.prototype.

  render = function render() {var _this2 = this;
    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(styles.datePickerWrapper, this.props.className) },

        _react2.default.createElement(_DayPickerInput2.default, {
          ref: function ref(_ref3) {_this2.datepickerRef = _ref3;},
          format: DATE_FORMAT,
          placeholder: DATE_FORMAT,
          onDayChange: this.handleChange,
          selectedDay: this.state.date,
          value: this.state.date,
          dayPickerProps: {
            modifiers: MODIFIERS,
            weekdaysShort: this.props.dayLabels,
            months: this.props.monthLabels },

          inputProps: { readOnly: this.props.isReadOnly, className: 'form-control' },
          formatDate: _moment.formatDate,
          parseDate: _moment.parseDate }),

        this.state.date ?
        _react2.default.createElement('span', { className: 'icon icon-close', onClick: this.clearDate }) :
        _react2.default.createElement('span', { className: 'icon icon-calendar', onClick: this.handleIconClick })));



  };return OMDatePicker;}(_react.Component);


OMDatePicker.propTypes = {
  onSelect: _propTypes2.default.func,
  dayLabels: _propTypes2.default.array,
  monthLabels: _propTypes2.default.array,
  value: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  isReadOnly: _propTypes2.default.bool };exports.default =


OMDatePicker;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMDatePicker/OMDatePicker.js
// module id = 2757
// module chunks = 0